import React, { useState } from 'react';
import { Box, Typography, Button, Container, Grid, useTheme, useMediaQuery, InputAdornment, TextField, IconButton } from '@mui/material';
import { SearchIcon, PlusIcon, XIcon, StoreIcon } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import TopBar from '../components/TopBar';
import Sidebar from '../components/Sidebar';
import SubAgentsTable from '../components/SubAgentsTable';
import SubAgentFormDrawer from '../components/SubAgentFormDrawer';
interface SubAgentsProps {
  onLogout: () => void;
}
const SubAgents: React.FC<SubAgentsProps> = ({
  onLogout
}) => {
  const navigate = useNavigate();
  const [mobileOpen, setMobileOpen] = useState(false);
  const [subAgentDrawerOpen, setSubAgentDrawerOpen] = useState(false);
  const [editSubAgent, setEditSubAgent] = useState<any>(null);
  const [searchQuery, setSearchQuery] = useState('');
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };
  const handleAddSubAgent = () => {
    setEditSubAgent(null);
    setSubAgentDrawerOpen(true);
  };
  const handleEditSubAgent = (subAgent: any) => {
    setEditSubAgent(subAgent);
    setSubAgentDrawerOpen(true);
  };
  const handleCloseSubAgentDrawer = () => {
    setSubAgentDrawerOpen(false);
    setEditSubAgent(null);
  };
  const handleSaveSubAgent = (subAgentData: any) => {
    // In a real app, this would save the sub agent data to the backend
    console.log('Save sub agent', subAgentData);
    setSubAgentDrawerOpen(false);
    // Show success toast (would be implemented with a toast library)
  };
  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchQuery(e.target.value);
  };
  const clearSearch = () => {
    setSearchQuery('');
  };
  const handleManageUsers = (subAgentId: string) => {
    // Use React Router navigation instead of window.location
    navigate(`/sub-agent-users?subAgent=${subAgentId}`);
  };
  return <Box sx={{
    display: 'flex',
    minHeight: '100vh',
    backgroundColor: '#F8FAFC'
  }} data-id="element-4397" data-mp="20xey4f2sw63x">
      <TopBar onMenuClick={handleDrawerToggle} onLogout={onLogout} data-id="element-4398" data-mp="1vylhwew4q102" />
      <Sidebar open={mobileOpen} onClose={handleDrawerToggle} activePage="sub-agents" data-id="element-4399" data-mp="29z61hd9vc0um" />
      <Box component="main" sx={{
      flexGrow: 1,
      p: 3,
      width: {
        sm: `calc(100% - ${240}px)`
      },
      ml: 0,
      mt: 8
    }} data-id="element-4400" data-mp="25ycauc51k7y1">
        <Container maxWidth="xl" data-id="element-4401" data-mp="1da6stx5dgx1w">
          {/* Header */}
          <Grid container spacing={2} alignItems="center" sx={{
          mb: 3
        }} data-id="element-4402" data-mp="1r0k1k1q38fsa">
            <Grid item xs={12} md={6} data-id="element-4403" data-mp="1m77f9y8vsl2p">
              <Box sx={{
              display: 'flex',
              alignItems: 'center'
            }} data-id="element-4404" data-mp="yixv10rbg5do">
                <StoreIcon size={24} color="#0EA5E9" data-id="element-4405" data-mp="ug1klxbxjfkt" />
                <Typography variant="h5" component="h1" sx={{
                ml: 1.5,
                fontWeight: 600
              }} data-id="element-4406" data-mp="kdxmph47k8u2">
                  Sub Agents
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={12} md={6} data-id="element-4407" data-mp="ffw2gsv1q3h0">
              <Box sx={{
              display: 'flex',
              gap: 2,
              flexWrap: 'wrap',
              justifyContent: {
                xs: 'flex-start',
                md: 'flex-end'
              }
            }} data-id="element-4408" data-mp="fcrnr1jyfpc3">
                <Button variant="contained" startIcon={<PlusIcon size={18} data-id="element-4410" data-mp="y3rbjzfpqt3s" />} onClick={handleAddSubAgent} data-id="element-4409" data-mp="y5lvbaf90f6a">
                  Add Sub Agent
                </Button>
              </Box>
            </Grid>
            <Grid item xs={12} data-id="element-4411" data-mp="3ix4id767qt93">
              <TextField fullWidth placeholder="Search sub agents by name, contact person, or email..." variant="outlined" value={searchQuery} onChange={handleSearch} InputProps={{
              startAdornment: <InputAdornment position="start" data-id="element-4413" data-mp="3keuouwi1pe1v">
                      <SearchIcon size={20} color="#475569" data-id="element-4414" data-mp="3kbysvdprczg2" />
                    </InputAdornment>,
              endAdornment: searchQuery ? <InputAdornment position="end" data-id="element-4415" data-mp="gynw3l16517v">
                      <IconButton size="small" onClick={clearSearch} data-id="element-4416" data-mp="by9qsaqyc5dj">
                        <XIcon size={18} data-id="element-4417" data-mp="c0cnteqiuyrr" />
                      </IconButton>
                    </InputAdornment> : null
            }} data-id="element-4412" data-mp="2xbhpe1np7o3" />
            </Grid>
          </Grid>
          {/* Sub Agents Table */}
          <SubAgentsTable onEditSubAgent={handleEditSubAgent} onManageUsers={handleManageUsers} searchQuery={searchQuery} data-id="element-4418" data-mp="2row7lna3el7r" />
          {/* Sub Agent Form Drawer */}
          <SubAgentFormDrawer open={subAgentDrawerOpen} subAgent={editSubAgent} onClose={handleCloseSubAgentDrawer} onSave={handleSaveSubAgent} data-id="element-4419" data-mp="1c5ojqnerzn0u" />
        </Container>
      </Box>
    </Box>;
};
export default SubAgents;